/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PostGenerateDefaultPasswordsRequest } from '../model';
// @ts-ignore
import { PostGenerateDefaultPasswordsResponse } from '../model';
// @ts-ignore
import { PostLoginResponse } from '../model';
// @ts-ignore
import { PostLoginWithMsRequest } from '../model';
// @ts-ignore
import { PostSessionRequest } from '../model';
// @ts-ignore
import { PostUserRequest } from '../model';
/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PostSessionRequest} postSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        check: async (postSessionRequest: PostSessionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postSessionRequest' is not null or undefined
            assertParamExists('check', 'postSessionRequest', postSessionRequest)
            const localVarPath = `/api/auth/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostSessionRequest} postSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkMobile: async (postSessionRequest: PostSessionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postSessionRequest' is not null or undefined
            assertParamExists('checkMobile', 'postSessionRequest', postSessionRequest)
            const localVarPath = `/api/auth/checkMobile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostLoginWithMsRequest} postLoginWithMsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkMobileV2: async (postLoginWithMsRequest: PostLoginWithMsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postLoginWithMsRequest' is not null or undefined
            assertParamExists('checkMobileV2', 'postLoginWithMsRequest', postLoginWithMsRequest)
            const localVarPath = `/api/auth/v2/checkMobile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postLoginWithMsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostLoginWithMsRequest} postLoginWithMsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkV2: async (postLoginWithMsRequest: PostLoginWithMsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postLoginWithMsRequest' is not null or undefined
            assertParamExists('checkV2', 'postLoginWithMsRequest', postLoginWithMsRequest)
            const localVarPath = `/api/auth/v2/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postLoginWithMsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate default passwords for specific users by email list (Administrator only)
         * @param {PostGenerateDefaultPasswordsRequest} postGenerateDefaultPasswordsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDefaultPasswordsByEmails: async (postGenerateDefaultPasswordsRequest: PostGenerateDefaultPasswordsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postGenerateDefaultPasswordsRequest' is not null or undefined
            assertParamExists('generateDefaultPasswordsByEmails', 'postGenerateDefaultPasswordsRequest', postGenerateDefaultPasswordsRequest)
            const localVarPath = `/api/auth/generate-default-passwords-by-emails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postGenerateDefaultPasswordsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSession: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logOut: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logOutMobile: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/log-out`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login user
         * @param {PostSessionRequest} postSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (postSessionRequest: PostSessionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postSessionRequest' is not null or undefined
            assertParamExists('login', 'postSessionRequest', postSessionRequest)
            const localVarPath = `/api/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostSessionRequest} postSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCreateSession: async (postSessionRequest: PostSessionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postSessionRequest' is not null or undefined
            assertParamExists('postCreateSession', 'postSessionRequest', postSessionRequest)
            const localVarPath = `/api/auth/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostUserRequest} postUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (postUserRequest: PostUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postUserRequest' is not null or undefined
            assertParamExists('register', 'postUserRequest', postUserRequest)
            const localVarPath = `/api/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PostSessionRequest} postSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async check(postSessionRequest: PostSessionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostLoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.check(postSessionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostSessionRequest} postSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkMobile(postSessionRequest: PostSessionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostLoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkMobile(postSessionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostLoginWithMsRequest} postLoginWithMsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkMobileV2(postLoginWithMsRequest: PostLoginWithMsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostLoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkMobileV2(postLoginWithMsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostLoginWithMsRequest} postLoginWithMsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkV2(postLoginWithMsRequest: PostLoginWithMsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostLoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkV2(postLoginWithMsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate default passwords for specific users by email list (Administrator only)
         * @param {PostGenerateDefaultPasswordsRequest} postGenerateDefaultPasswordsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateDefaultPasswordsByEmails(postGenerateDefaultPasswordsRequest: PostGenerateDefaultPasswordsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostGenerateDefaultPasswordsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateDefaultPasswordsByEmails(postGenerateDefaultPasswordsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSession(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSession(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logOut(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logOut(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logOutMobile(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logOutMobile(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Login user
         * @param {PostSessionRequest} postSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(postSessionRequest: PostSessionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostLoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(postSessionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostSessionRequest} postSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCreateSession(postSessionRequest: PostSessionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCreateSession(postSessionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostUserRequest} postUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(postUserRequest: PostUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(postUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @param {PostSessionRequest} postSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        check(postSessionRequest: PostSessionRequest, options?: any): AxiosPromise<PostLoginResponse> {
            return localVarFp.check(postSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostSessionRequest} postSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkMobile(postSessionRequest: PostSessionRequest, options?: any): AxiosPromise<PostLoginResponse> {
            return localVarFp.checkMobile(postSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostLoginWithMsRequest} postLoginWithMsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkMobileV2(postLoginWithMsRequest: PostLoginWithMsRequest, options?: any): AxiosPromise<PostLoginResponse> {
            return localVarFp.checkMobileV2(postLoginWithMsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostLoginWithMsRequest} postLoginWithMsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkV2(postLoginWithMsRequest: PostLoginWithMsRequest, options?: any): AxiosPromise<PostLoginResponse> {
            return localVarFp.checkV2(postLoginWithMsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate default passwords for specific users by email list (Administrator only)
         * @param {PostGenerateDefaultPasswordsRequest} postGenerateDefaultPasswordsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDefaultPasswordsByEmails(postGenerateDefaultPasswordsRequest: PostGenerateDefaultPasswordsRequest, options?: any): AxiosPromise<PostGenerateDefaultPasswordsResponse> {
            return localVarFp.generateDefaultPasswordsByEmails(postGenerateDefaultPasswordsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSession(options?: any): AxiosPromise<void> {
            return localVarFp.getSession(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logOut(options?: any): AxiosPromise<void> {
            return localVarFp.logOut(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logOutMobile(options?: any): AxiosPromise<void> {
            return localVarFp.logOutMobile(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login user
         * @param {PostSessionRequest} postSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(postSessionRequest: PostSessionRequest, options?: any): AxiosPromise<PostLoginResponse> {
            return localVarFp.login(postSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostSessionRequest} postSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCreateSession(postSessionRequest: PostSessionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.postCreateSession(postSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostUserRequest} postUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(postUserRequest: PostUserRequest, options?: any): AxiosPromise<void> {
            return localVarFp.register(postUserRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for check operation in AuthApi.
 * @export
 * @interface AuthApiCheckRequest
 */
export interface AuthApiCheckRequest {
    /**
     * 
     * @type {PostSessionRequest}
     * @memberof AuthApiCheck
     */
    readonly postSessionRequest: PostSessionRequest
}

/**
 * Request parameters for checkMobile operation in AuthApi.
 * @export
 * @interface AuthApiCheckMobileRequest
 */
export interface AuthApiCheckMobileRequest {
    /**
     * 
     * @type {PostSessionRequest}
     * @memberof AuthApiCheckMobile
     */
    readonly postSessionRequest: PostSessionRequest
}

/**
 * Request parameters for checkMobileV2 operation in AuthApi.
 * @export
 * @interface AuthApiCheckMobileV2Request
 */
export interface AuthApiCheckMobileV2Request {
    /**
     * 
     * @type {PostLoginWithMsRequest}
     * @memberof AuthApiCheckMobileV2
     */
    readonly postLoginWithMsRequest: PostLoginWithMsRequest
}

/**
 * Request parameters for checkV2 operation in AuthApi.
 * @export
 * @interface AuthApiCheckV2Request
 */
export interface AuthApiCheckV2Request {
    /**
     * 
     * @type {PostLoginWithMsRequest}
     * @memberof AuthApiCheckV2
     */
    readonly postLoginWithMsRequest: PostLoginWithMsRequest
}

/**
 * Request parameters for generateDefaultPasswordsByEmails operation in AuthApi.
 * @export
 * @interface AuthApiGenerateDefaultPasswordsByEmailsRequest
 */
export interface AuthApiGenerateDefaultPasswordsByEmailsRequest {
    /**
     * 
     * @type {PostGenerateDefaultPasswordsRequest}
     * @memberof AuthApiGenerateDefaultPasswordsByEmails
     */
    readonly postGenerateDefaultPasswordsRequest: PostGenerateDefaultPasswordsRequest
}

/**
 * Request parameters for login operation in AuthApi.
 * @export
 * @interface AuthApiLoginRequest
 */
export interface AuthApiLoginRequest {
    /**
     * 
     * @type {PostSessionRequest}
     * @memberof AuthApiLogin
     */
    readonly postSessionRequest: PostSessionRequest
}

/**
 * Request parameters for postCreateSession operation in AuthApi.
 * @export
 * @interface AuthApiPostCreateSessionRequest
 */
export interface AuthApiPostCreateSessionRequest {
    /**
     * 
     * @type {PostSessionRequest}
     * @memberof AuthApiPostCreateSession
     */
    readonly postSessionRequest: PostSessionRequest
}

/**
 * Request parameters for register operation in AuthApi.
 * @export
 * @interface AuthApiRegisterRequest
 */
export interface AuthApiRegisterRequest {
    /**
     * 
     * @type {PostUserRequest}
     * @memberof AuthApiRegister
     */
    readonly postUserRequest: PostUserRequest
}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @param {AuthApiCheckRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public check(requestParameters: AuthApiCheckRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).check(requestParameters.postSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiCheckMobileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public checkMobile(requestParameters: AuthApiCheckMobileRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).checkMobile(requestParameters.postSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiCheckMobileV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public checkMobileV2(requestParameters: AuthApiCheckMobileV2Request, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).checkMobileV2(requestParameters.postLoginWithMsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiCheckV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public checkV2(requestParameters: AuthApiCheckV2Request, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).checkV2(requestParameters.postLoginWithMsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate default passwords for specific users by email list (Administrator only)
     * @param {AuthApiGenerateDefaultPasswordsByEmailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public generateDefaultPasswordsByEmails(requestParameters: AuthApiGenerateDefaultPasswordsByEmailsRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).generateDefaultPasswordsByEmails(requestParameters.postGenerateDefaultPasswordsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public getSession(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).getSession(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public logOut(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).logOut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public logOutMobile(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).logOutMobile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login user
     * @param {AuthApiLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public login(requestParameters: AuthApiLoginRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).login(requestParameters.postSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiPostCreateSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public postCreateSession(requestParameters: AuthApiPostCreateSessionRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).postCreateSession(requestParameters.postSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public register(requestParameters: AuthApiRegisterRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).register(requestParameters.postUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
